// extracted by mini-css-extract-plugin
module.exports = {"FullPageSpinner":"index-module--FullPageSpinner--1p0be"};